<template>
    <div class="my-details-and-documents-component">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <ul class="tabs">
                        <li :class="{ 'active' : active == 'details'}">
                            <span @click="toggle('details')">Details</span>
                        </li>
                        <li :class="{ 'active' : active == 'documents'}">
                            <span @click="toggle('documents')">Documents</span>
                        </li>
                        <hr/>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center" v-if="!loaded">
                    <loading-icon/>
                </div>
                <div class="col-12" v-else>
                    <div v-if="active === 'details'" class="details">
                        <h1>My <strong>Details</strong></h1>
                        <ul class="employee-details">
                            <li class="title">Employee details</li>
                            <li><span class="key">Your name:</span><span class="value">{{ profile.fullName }}</span>
                            </li>
                            <li><span class="key">Email address:</span><span class="value">{{ profile.emailAddress }}</span></li>
                            <li><span class="key">Mobile phone:</span><span class="value">{{ profile.mobile }}</span></li>
                            <li><span class="key">Driver Grades:</span><span class="value">{{ profile.driverGrades }}</span></li>
                        </ul>
                        <ul class="employee-address">
                            <li class="title">Employee address</li>
                            <li v-html="profile.homeAddress"></li>
                        </ul>
                      <ul class="employee-details">
                        <li class="title">Driver details</li>
                        <li><span class="key">Driver Grades:</span><span class="value">{{ profile.driverGrades }}</span></li>
                      </ul>
                      <hr/>
                        <ul class="actions">
                            <li><a href="#" @click="$router.push('/request-password-reset')">Reset my password</a></li>
                        </ul>
                    </div>
                    <div v-if="active === 'documents'" class="documents">
                        <h1>My <strong>Documents</strong></h1>
                        <h2>Your documents and agreements</h2>
                            <table class="table bg-transparent">
                                <thead>
                                    <tr>
                                        <th scope="col">Title</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Signed</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="policy in policies">
                                        <th scope="row">{{ policyName(policy.policyName) }}</th>
                                        <td v-if="policy.accepted" class="status status--signed">Signed</td>
                                        <td v-else class="status status--awaiting-signature">Awaiting Signature</td>
                                        <td><span v-if="policy.accepted">{{ formatDate(policy.acceptedDateTime) }}</span></td>
                                        <td>
                                            <button class="button button--charcoal-ghost button--small w-100" @click="showModal(policy.policyName)">Read</button>
                                            <text-modal-component v-if="modalShow === policy.policyName" @close="showModal('')">
                                              <template v-slot:header>
    <!--                                            <h3>{{policyName(policy.policyName)}}</h3>-->
                                              </template>
                                              <template v-slot:body>
                                                <span v-html="policy.policyContentBase64"></span>
                                              </template>
                                            </text-modal-component>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import {EventBus} from "@/event-bus";
import TextModalComponent from "@/components/text-modal-component.vue";
import LoadingIcon from "@/components/loading-icon.vue";
import {formatDate} from "@/helpers/filters";

export default {
    components: { EventBus, TextModalComponent, LoadingIcon },

    data() {
        return {
            active: 'details',
            modalShow: null
        };
    },

    props: ['session'],

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.vehicles = [];

            EventBus.$emit('loadingTitle', 'Fetching Driver Details');
            EventBus.$emit('fetchData', [
              'driverprofile',
              'drivergrades',
              'driverprofile/quotepolicies'
            ]);
            vm.type = vm.$route.meta.type;
        })
    },

    computed: {
        loaded() {
            return !!(this.session?.driverProfile?.driverGrades);
        },
        profile() {
            let profile = {};
            if (!this.loaded) {
                return profile;
            }
            const dp = this.session.driverProfile;
            profile.fullName = dp.contacts[0].fullName;
            profile.forename = dp.firstName;
            profile.surname = dp.surname;
            profile.emailAddress = dp.contacts[0].emailAddress;
            profile.mobile = dp.contacts[0].mobile;
            profile.homeAddress = dp.homeAddress ? dp.homeAddress.replace(/(?:\r\n|\r|\n)/g, '<br/>') : '';
            profile.driverGrades = dp.driverGrades.map(grade => grade.name).join(", ");
            return profile;
        },
        policies() {
            let policies = [];
            if (!this.loaded) {
                return policies;
            }
            policies = this.session.driverProfile.quotePolicies;
            return policies;
        }

    },

    methods: {
      formatDate,
        toggle(id) {
            this.active = id;
        },
        showModal(policyName) {
            this.modalShow = policyName;
        },
        policyName(name) {
          return (name === 'Default' ? 'EULA' : name);
        },
    }


}
</script>

